
//== Include Bootstrap.
//
//##

//import 'bootstrap/js/src/base-component';
//import 'bootstrap/js/src/alert';
//import 'bootstrap/js/src/button';
//import 'bootstrap/js/src/carousel';
//import 'bootstrap/js/src/collapse';
//import 'bootstrap/js/src/dropdown';
//import 'bootstrap/js/src/modal';
//import 'bootstrap/js/src/offcanvas';
//import 'bootstrap/js/src/popover';
//import 'bootstrap/js/src/scrollspy';
//import 'bootstrap/js/src/tab';
//import 'bootstrap/js/src/toast';
//import 'bootstrap/js/src/tooltip';



//== Include libraries.
//
//##

import './Libraries/Vendors/Bootstrap/popper.min'
import './Libraries/Vendors/SlickSlider/slick.min'
import './Libraries/Vendors/Bootstrap/bootstrap.bundle.min'
import './Libraries/Vendors/Leafet/leaflet'
import './Libraries/main'


//== Include stuff for extensions.
//
//##

import './Extensions/datamintsCarierFairs'
import './Extensions/datamintsTrainingPlaces'
import './Extensions/datamintsBauchecker'
import './Extensions/datamintsJobFilter'
import './Extensions/datamintsConsentmanager'


//== Include stuff for content elements.
//
//##

//import './ContentElements/XXX'


//== Include stuff for parts of the websites.
//
//##

//import './Parts/XXX.js'
// import './Parts/navigationHover'
// import './Parts/datamintsJobs'
import './Parts/lightbox'
// import './Parts/featureFlags'


//== Write your own JavaScript stuff here.
//
//##

/*
window.addEventListener('DOMContentLoaded', () => {
	  console.log('Document is ready (global, footer).');
});
*/
